import { type JSX } from 'react/jsx-runtime';

export const LetterOpenDark = (): JSX.Element => (
	<svg
		width="48"
		height="40"
		viewBox="0 0 48 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<g clipPath="url(#clip0_5144_6112)">
			<rect
				width="46.9907"
				height="40"
				transform="translate(0.503906)"
				fill="white"
				fillOpacity="0.01"
			/>
			<path
				d="M47.4509 16.471L29.2314 1.83419C27.7418 0.646682 25.8933 0 23.9883 0C22.0834 0 20.2348 0.646682 18.7453 1.83419L0.547598 16.471H0.503906V39.9773H47.4946V16.471H47.4509Z"
				fill="#959AA1"
			/>
			<path d="M41.618 4.89258H6.05273V33.69H41.618V4.89258Z" fill="#FAFBFC" />
			<path d="M37.5542 12.4961H10.0938V12.933H37.5542V12.4961Z" fill="#3384FF" />
			<path d="M41.618 4.25977H6.05273V6.91405H41.618V4.25977Z" fill="#D0D4DC" />
			<path d="M24.4466 14.5938H10.0938V15.0307H24.4466V14.5938Z" fill="#3384FF" />
			<path d="M37.5542 10.3984H10.0938V10.8354H37.5542V10.3984Z" fill="#3384FF" />
			<path d="M37.5542 18.7656H10.0938V19.2025H37.5542V18.7656Z" fill="#3384FF" />
			<path d="M37.5542 20.8633H10.0938V21.3002H37.5542V20.8633Z" fill="#3384FF" />
			<path d="M25.8884 22.9609H10.0938V23.3979H25.8884V22.9609Z" fill="#3384FF" />
			<path
				d="M47.4946 40.0001C39.5208 40.0001 34.4526 38.7111 31.2849 36.8979C23.9665 32.6598 23.049 26.5648 15.4029 21.4747C9.98506 17.8701 4.3488 16.8433 0.503906 16.5156V40.0001H47.4946Z"
				fill="url(#paint0_linear_5144_6112)"
			/>
			<path
				d="M0.503906 40.0001C8.52138 40.0001 13.546 38.7111 16.7136 36.8979C24.032 32.6598 24.9277 26.5648 32.5957 21.4747C37.9916 17.8701 43.6497 16.8433 47.4946 16.5156V40.0001H0.503906Z"
				fill="#D0D4DC"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_5144_6112"
				x1="6.0039"
				y1="42.5"
				x2="14.0151"
				y2="2.22797"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#9AA1AB" />
				<stop offset="0.250414" stopColor="#C1C7D0" />
				<stop offset="0.720522" stopColor="#FAFBFC" />
			</linearGradient>
			<clipPath id="clip0_5144_6112">
				<rect width="46.9907" height="40" fill="white" transform="translate(0.503906)" />
			</clipPath>
		</defs>
	</svg>
);
